export default __webpack_public_path__ + "static/5_26-62d5b2b9fb64389bcd2c3a4a88982323.png";